<template>
  <div class="page-login">
    <!-- <img :src="logoImg" class="logo-img" /> -->
    <div class="login-content">
      <div class="system-title">健康监护系统</div>
      <div class="login-box">
        <div class="login-top">
          <div class="login-title">登录</div>
          <div>
            <el-form :model="loginData" ref="loginForm" :rules="loginRule" @submit.native.prevent>
              <el-form-item prop="username">
                <el-input v-model="loginData.username" placeholder="账户名" class="form-input">
                  <img :src="userImg" slot="prefix" class="form-img" />
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="loginData.password" type="password" placeholder="密码" show-password>
                  <img :src="pwdImg" slot="prefix" class="form-img" />
                </el-input>
              </el-form-item>
            </el-form>
            <div class="password-box">
              <div>
                <el-checkbox v-model="remPwd" class="rem-pwd"></el-checkbox>记住密码
              </div>
              <div>忘记密码</div>
            </div>
          </div>

          <el-button class="login-btn" @click="login" :loading='logining'>登录</el-button>
        </div>
        <div class="login-bottom"></div>
      </div>
    </div>

    <a class="text" href="https://beian.miit.gov.cn/">冀ICP备19036069号-2</a>
  </div>
</template>

<script>
import { login } from "../api/user";

export default {
  name: "Login",
  data() {
    return {
      logoImg: require("../assets/images/login/logo.png"),
      loginData: {},
      userImg: require("../assets/images/login/user.png"),
      pwdImg: require("../assets/images/login/password.png"),
      remPwd: false,

      loginRule: {
        username: [
          { required: true, message: "请输入用户名", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
      },

      logining: false
    };
  },
  created() {

  },
  mounted() {
    window.addEventListener("keydown", this.enterLogin, false);

    if (this.user) {
      this.$router.push("/real-time");
    }

    let data = JSON.parse(localStorage.getItem('healthyLoginData'))

    if (data) {
      this.loginData = data
    }

    if (this.loginData.password) {
      this.remPwd = true
    }
  },
  computed: {
    user: function () {
      return this.$store.getters.user
    }
  },
  methods: {
    enterLogin(e) {
      if (e.key == "Enter") {
        this.login();
      }
    },

    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.logining = true
          login({
            username: this.loginData.username,
            password: this.loginData.password,
          }).then((res) => {
            this.logining = false
            this.$store.dispatch('setUser', res.data)

            if (this.remPwd) {
              localStorage.setItem('healthyLoginData', JSON.stringify({
                username: this.loginData.username,
                password: this.loginData.password
              }))
            } else {
              localStorage.setItem('healthyLoginData', JSON.stringify({
                username: this.loginData.username
              }))
            }

            localStorage.setItem('healthyToken', res.data.token)

            this.$message({
              type: "success",
              message: "登录成功",
            });

            this.$router.push("/real-time");
          }).catch(err => {
            this.logining = false
          })
        }
      });
    },
  },
  watch: {},

  beforeDestroy() {
    window.removeEventListener("keydown", this.enterLogin, false);
  },
};
</script>

<style scoped lang='less'>
.page-login {
  width: 100%;
  height: 100vh;
  background: linear-gradient(to bottom,
      rgba(235, 240, 252, 0.23),
      rgba(0, 63, 254, 0.18));
  position: relative;
  overflow: hidden;

  .logo-img {
    width: 108px;
    height: 48px;
    position: absolute;
    top: 30px;
    left: 30px;
  }

  .login-content {
    width: 384px;
    position: absolute;
    bottom: 30%;
    left: 50%;
    margin-left: -192px;

    .system-title {
      font-size: 32px;
      color: #26415f;
      text-align: center;
      margin-bottom: 50px;
    }

    .login-box {
      width: 384px;
      height: 384px;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      border-radius: 12px;
      box-shadow: rgba(17, 46, 74, 0.15) 0 15px 25px;

      .login-top {
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
        flex: 1;
        overflow: hidden;

        .login-title {
          height: 32px;
          line-height: 32px;
          font-size: 32px;
          color: #26415f;
          text-align: center;
          margin: 41px 0;
        }

        .form-img {
          padding: 10px 5px;
        }

        .password-box {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #26415f;
          margin-bottom: 22px;

          .rem-pwd {
            margin-right: 10px;
          }
        }

        .login-btn {
          width: 100%;
          height: 40px;
          font-size: 14px;
          color: #fff;
          background: #1d63fd;
          border-radius: 8px;
          border: none;
        }
      }

      .login-bottom {
        width: 100%;
        height: 50px;
        background: #ebf0fc;
      }
    }
  }

  .text {
    color: #bbb;
    font-size: 12px;
    text-decoration: none;
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
  }

  .text:hover {
    color: #000000;
  }
}
</style>
<style>
.page-login .el-input__inner {
  padding-left: 40px !important;
  border: 1px solid#a4b8cf;
  border-radius: 8px;
}

.el-form-item {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue